import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import withStyles from "@mui/styles/withStyles";
import classNames from "classnames";

import {
  OK,
  NO_FOOTAGE,
  UNKNOWN,
  UNSPECIFIED_ERROR,
  mapToDisplay,
} from "../CameraHealth";

import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";

import { orange, green, grey, red } from "@mui/material/colors";

const cameraHealthStyles = () => ({
  cameraOkIcon: {
    color: green[500],
  },
  cameraIssueIcon: {
    color: orange[500],
  },
  cameraUnknownIcon: {
    color: grey[400],
  },
  cameraErrorIcon: {
    color: red[500],
  },
});

const iconFor = (status) => {
  if (status === OK) return "camera";
  if (status === NO_FOOTAGE) return "error_outline";
  if (status === UNKNOWN) return "help_outline";
  if (status === UNSPECIFIED_ERROR) return "report_problem";
  return "help_outline";
};

const CameraHealthIcon = ({
  classes,
  className,
  camera: { camera, status, asAt, since },
}) => {
  const tip = (
    <span>
      <b>{camera}</b>: {mapToDisplay(status)} for {moment(since).fromNow(true)}{" "}
      (last updated: {moment(asAt).format("lll")})
    </span>
  );
  return (
    <Tooltip title={tip}>
      <Icon
        className={classNames(className, {
          [classes.cameraOkIcon]: status === OK,
          [classes.cameraIssueIcon]: status === NO_FOOTAGE,
          [classes.cameraUnknownIcon]: status === UNKNOWN,
          [classes.cameraErrorIcon]: status === UNSPECIFIED_ERROR,
        })}
      >
        {iconFor(status)}
      </Icon>
    </Tooltip>
  );
};

CameraHealthIcon.propTypes = {
  camera: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
};

export default withStyles(cameraHealthStyles)(CameraHealthIcon);
